var exports = {
  "kL": "container__399RdM",
  "wx": "header__ILQQN_",
  "j4": "languageLabel__klYHc_",
  "zQ": "codeWrapper__s7l0Au",
  "IR": "codeHighlight__iJk5Oe",
  "Ie": "codeTextarea__YFye2U",
  "hd": "codeTextareaHighlighted__Q9LgnN",
  "yZ": "collapsed__7iqZ8M",
  "aY": "headerButton__UiFC69",
};

module.exports = exports;
